import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import VoteBreakdownTooltip from "./tooltips/VoteBreakdownTooltip";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { getApprovalDropStatus } from "@/helpers/waves/approve-wave.helpers";
interface ParticipationDropRatingsTotalSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function ParticipationDropRatingsTotalSection(t0) {
  const $ = _c(38);
  const {
    drop,
    ratingsData,
    winningThreshold,
    isVotingClosed: t1
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const {
    currentRating
  } = ratingsData;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const totalValueClass = currentRating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const displayWinningThreshold = typeof winningThreshold === "number" && winningThreshold > 0 ? winningThreshold : null;
  const hasWinningThreshold = displayWinningThreshold !== null;
  let approvalStatusClass;
  let t2;
  if ($[0] !== displayWinningThreshold || $[1] !== drop || $[2] !== isVotingClosed) {
    const approvalStatus = displayWinningThreshold !== null ? getApprovalDropStatus({
      drop,
      isClosed: isVotingClosed,
      winningThreshold: displayWinningThreshold
    }) : null;
    const approvalStatusKind = approvalStatus?.kind;
    if (approvalStatusKind === "approved" || approvalStatusKind === "reached_threshold") {
      approvalStatusClass = "tw-text-emerald-400";
    } else {
      if (approvalStatusKind === "closed") {
        approvalStatusClass = "tw-text-amber-300";
      }
    }
    bb0: {
      if (approvalStatus === null) {
        t2 = null;
        break bb0;
      }
      if (approvalStatus.kind === "approved") {
        t2 = "Approved";
        break bb0;
      }
      if (approvalStatus.kind === "reached_threshold") {
        t2 = "Reached threshold";
        break bb0;
      }
      if (approvalStatus.kind === "closed") {
        t2 = "Closed";
        break bb0;
      }
      t2 = `Needs ${formatNumberWithCommas(approvalStatus.remaining ?? 0)}`;
    }
    $[0] = displayWinningThreshold;
    $[1] = drop;
    $[2] = isVotingClosed;
    $[3] = approvalStatusClass;
    $[4] = t2;
  } else {
    approvalStatusClass = $[3];
    t2 = $[4];
  }
  const approvalStatusLabel = t2;
  const t3 = `tw-font-medium ${totalValueClass}`;
  const t4 = currentRating < 0 && "-";
  let t5;
  if ($[5] !== currentRating) {
    t5 = formatNumberWithCommas(Math.abs(currentRating));
    $[5] = currentRating;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== displayWinningThreshold) {
    t7 = displayWinningThreshold !== null && <><span className="tw-font-medium tw-text-iron-500">/</span><span className="tw-font-medium tw-text-iron-50">{formatNumberWithCommas(displayWinningThreshold)}</span></>;
    $[11] = displayWinningThreshold;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== currentRating || $[14] !== drop.rating_prediction) {
    t8 = <DropVoteProgressing current={currentRating} projected={drop.rating_prediction} compact={true} />;
    $[13] = currentRating;
    $[14] = drop.rating_prediction;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1.5">{t6}{t7}{t8}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `total-rating-${drop.id}`;
  let t11;
  if ($[20] !== approvalStatusClass || $[21] !== approvalStatusLabel || $[22] !== hasWinningThreshold || $[23] !== votingLabel) {
    t11 = hasWinningThreshold && approvalStatusLabel !== null ? <span className={approvalStatusClass}>{approvalStatusLabel}</span> : <>{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</>;
    $[20] = approvalStatusClass;
    $[21] = approvalStatusLabel;
    $[22] = hasWinningThreshold;
    $[23] = votingLabel;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <span className="tw-cursor-help tw-whitespace-nowrap tw-font-normal tw-text-iron-400" data-tooltip-id={t10}>{t11}</span>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = `total-rating-${drop.id}`;
  let t14;
  if ($[28] !== drop || $[29] !== ratingsData) {
    t14 = <VoteBreakdownTooltip drop={drop} ratingsData={ratingsData} />;
    $[28] = drop;
    $[29] = ratingsData;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <Tooltip id={t13} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{t14}</Tooltip>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t15 || $[36] !== t9) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t9}{t12}{t15}</div>;
    $[34] = t12;
    $[35] = t15;
    $[36] = t9;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}